import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Col, FormGroup, Label, Row } from "reactstrap";
import { useHistory } from "react-router-dom";
import { initialFiledFunc } from "../../components/Common/validationFunction";
import { C_Button } from "../../components/Common/CommonButton";
import { C_DatePicker } from "../../CustomValidateForm";
import * as _cfunc from "../../components/Common/CommonFunction";
import { mode, pageId } from "../../routes";
import { MetaTags } from "react-meta-tags";
import C_Report from "../../components/Common/C_Report";
import Select from "react-select";
import {
    BreadcrumbShowCountlabel,
    commonPageField,
    commonPageFieldSuccess,
    get_Category_List_ForDropDownAPI,
    getpdfReportdataSuccess,
} from "../../store/actions";
import DynamicColumnHook from "../../components/Common/TableCommonFunc";
import { divisionDropdown_Forlogin_ChangeDivisionPage_ApiCall } from "../../helpers/backend_helper";
import { allLabelWithZero } from "../../components/Common/CommonErrorMsg/HarderCodeData";
import { ExcelReportComponent } from "../../components/Common/ReportCommonFunc/ExcelDownloadWithCSS";
import { customAlert } from "../../CustomAlert/ConfirmDialog";
import GlobalCustomTable from "../../GlobalCustomTable";
import * as report from "../../Reports/ReportIndex";
import {
    Rate_List_Report_GoButton_Action,
    Rate_List_Report_GoButton_Success,
} from "../../store/Report/RateListReportRedux/action";

const RateListReport = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const currentDate_ymd = _cfunc.date_ymd_func();

    const fields = {
        FromDate: currentDate_ymd,
        Category: allLabelWithZero,
    };

    const [state, setState] = useState(() => initialFiledFunc(fields));
    const [userPageAccessState, setUserAccState] = useState("");
    const [DivisionOptions, setDivisionOptions] = useState([]);
    const [activeBtn, setActiveBtn] = useState("");

    const reducers = useSelector((state) => ({
        tableData: state.RateListReportReducer.Rate_List_ReportGobtn,
        GoBtnLoading: state.RateListReportReducer.goBtnLoding,
        userAccess: state.Login.RoleAccessUpdateData,
        pageField: state.CommonPageFieldReducer.pageField,
        CategoryList: state.categoryTypeReducer.categoryListData,
    }));

    const { userAccess, tableData, GoBtnLoading, pageField, CategoryList } = reducers;
    const { Data = [], Type } = tableData;

    useEffect(() => {
        const fetchInitialData = async () => {
            dispatch(commonPageFieldSuccess(null));
            dispatch(commonPageField(pageId.RATE_LIST_REPORT));
            dispatch(BreadcrumbShowCountlabel(`Count:${0}`));

            const resp = await divisionDropdown_Forlogin_ChangeDivisionPage_ApiCall(
                _cfunc.loginEmployeeID()
            );

            if (resp.Status === true && resp.StatusCode === 200) {
                const data = resp.Data.map((i) => ({
                    value: i.Party_id,
                    label: i.PartyName,
                }));
                setDivisionOptions(data);
            }
        };

        fetchInitialData();
        dispatch(get_Category_List_ForDropDownAPI());

        return () => {
            dispatch(commonPageFieldSuccess(null));
            dispatch(Rate_List_Report_GoButton_Success([]));
        };
    }, [dispatch]);

    const [tableColumns] = DynamicColumnHook({ pageField });
    const values = { ...state.values };
    const location = { ...history.location };
    const hasShowModal = props.hasOwnProperty(mode.editValue);

    // ✅ User Access
    useEffect(() => {
        let locationPath = hasShowModal ? props.masterPath : location.pathname;
        const userAcc = userAccess?.find(
            (inx) => `/${inx.ActualPagePath}` === locationPath
        );
        if (userAcc) {
            setUserAccState(userAcc);
            _cfunc.breadcrumbReturnFunc({ dispatch, userAcc });
        }
    }, [userAccess, dispatch, hasShowModal, location.pathname, props.masterPath]);

    // ✅ Excel download effect (force-enable Category column only for Excel)
    useEffect(() => {
        if (Type === "excel") {
            try {
                const categoryLabel = values.Category?.label || "All";

                // Step 1️⃣ — Clone table data and add Category column with selected value
                const excelDataWithCategory = (Data || []).map((row) => ({
                    ...row,
                    CategoryName: categoryLabel, // match ControlID for consistency
                }));

                // Step 2️⃣ — Clone PageFieldMaster and force-enable "Category" column
                const updatedPageFieldMaster =
                    pageField?.PageFieldMaster?.map((field) => {
                        if (
                            field.ControlID === "CategoryName" ||
                            field.FieldLabel?.toLowerCase() === "category"
                        ) {
                            return {
                                ...field,
                                ShowInDownload: true, // ✅ force show in Excel
                                ShowInListPage: true, // optional (doesn't affect UI)
                            };
                        }
                        return field;
                    }) || [];

                // Step 3️⃣ — Build updated structure for Excel export
                const updatedPageField = {
                    ...pageField,
                    PageFieldMaster: updatedPageFieldMaster,
                };

                // Step 4️⃣ — Call Excel component with updated data and structure
                ExcelReportComponent({
                    pageField: updatedPageField,
                    excelTableData: excelDataWithCategory,
                    excelFileName: "Rate List Report",
                });
            } catch (error) {
                _cfunc.CommonConsole(error);
            }
        }
    }, [Type, Data, pageField, values.Category]);


    // ✅ Print and alert handling
    useEffect(() => {
        if (tableData.Status === true) {
            if (tableData.StatusCode === 200 && Type === "Print") {
                const config = {
                    rowData: {
                        ReportType: report.RateReport,
                        Status: tableData.Status,
                        StatusCode: tableData.StatusCode,
                        Data: tableData.Data,
                    },
                };
                config.rowData.Data["Date"] = `Effective Date: ${_cfunc.date_dmy_func(values.FromDate)}`;
                config.rowData.Data["CategoryLabel"] = values.Category?.label || "All";
                dispatch(getpdfReportdataSuccess(config.rowData));
                dispatch(Rate_List_Report_GoButton_Success([]));
            } else if (tableData.StatusCode === 204) {
                customAlert({
                    Type: 3,
                    Message: tableData.Message,
                });
                dispatch(Rate_List_Report_GoButton_Success([]));
            }
        }
    }, [tableData, Type, dispatch, values.FromDate]);

    // ✅ Date change handler
    function fromdateOnchange(e, date) {
        setState((prev) => ({
            ...prev,
            values: { ...prev.values, FromDate: date },
            hasValid: { ...prev.hasValid, FromDate: { valid: true } },
        }));
        dispatch(Rate_List_Report_GoButton_Success([]));
    }

    // ✅ Category dropdown onChange handler
    const handleCategoryChange = (selectedOption) => {
        setState((prev) => ({
            ...prev,
            values: { ...prev.values, Category: selectedOption },
            hasValid: { ...prev.hasValid, Category: { valid: true } },
        }));
        dispatch(Rate_List_Report_GoButton_Success([]));
    };

    // ✅ Go Button Handler
    function goButtonHandler(BtnID) {
        try {
            setActiveBtn(BtnID);
            const selectedCategory = values.Category?.value;

            const jsonBody = JSON.stringify({
                EffectiveDate: values.FromDate,
                PartyID: _cfunc.loginPartyID(),
                CompanyID: _cfunc.loginCompanyID(),
                CategoryId: selectedCategory, // ✅ FIXED key casing
            });

            dispatch(Rate_List_Report_GoButton_Action({ jsonBody, btnId: BtnID }));
        } catch (error) {
            _cfunc.CommonConsole(error);
        }
    }


    const CategoryList_DropdownOptions = [
        allLabelWithZero,
        ...CategoryList.map((cat) => ({
            value: cat.id,
            label: cat.Name,
        })),
    ];


    return (
        <React.Fragment>
            <MetaTags>{_cfunc.metaTagLabel(userPageAccessState)}</MetaTags>

            <div className="px-2 c_card_filter text-black">
                <Row>
                    <Col sm={4}>
                        <FormGroup className="row mt-2">
                            <Label className="col-sm-4 p-2" style={{ width: "106px" }}>
                                Effective Date
                            </Label>
                            <Col sm="7">
                                <C_DatePicker
                                    name="FromDate"
                                    value={values.FromDate}
                                    onChange={fromdateOnchange}
                                />
                            </Col>
                        </FormGroup>
                    </Col>

                    <Col sm={4}>
                        <FormGroup className="row mt-2">
                            <Label className="col-sm-4 p-2" style={{ width: "106px" }}>
                                Category
                            </Label>
                            <Col sm="7">
                                <Select
                                    name="Category"
                                    value={values.Category}
                                    isSearchable
                                    className="react-dropdown"
                                    classNamePrefix="dropdown"
                                    options={CategoryList_DropdownOptions}
                                    onChange={handleCategoryChange}
                                />
                            </Col>
                        </FormGroup>
                    </Col>

                    <Col sm={4} className="d-flex justify-content-end">
                        <C_Button
                            type="button"
                            spinnerColor="white"
                            loading={GoBtnLoading && activeBtn === "show"}
                            className="btn btn-success m-3 mr"
                            onClick={() => goButtonHandler("show")}
                        >
                            Show
                        </C_Button>

                        <C_Button
                            type="button"
                            spinnerColor="white"
                            loading={GoBtnLoading && activeBtn === "excel"}
                            className="btn btn-primary m-3 mr"
                            onClick={() => goButtonHandler("excel")}
                        >
                            Excel
                        </C_Button>

                        <C_Button
                            type="button"
                            spinnerColor="white"
                            loading={GoBtnLoading && activeBtn === "Print"}
                            className="btn btn-primary m-3 mr"
                            onClick={() => goButtonHandler("Print")}
                        >
                            Print
                        </C_Button>
                    </Col>
                </Row>
            </div>

            <GlobalCustomTable
                keyField={"id"}
                data={Type === "show" ? Data : []}
                columns={tableColumns}
                id="table_Arrow"
                noDataIndication={
                    <div className="text-danger text-center">Record Not available</div>
                }
                onDataSizeChange={({ dataCount, filteredData = [] }) => {
                    dispatch(
                        BreadcrumbShowCountlabel(
                            `Count:${dataCount} currency_symbol ${_cfunc.TotalAmount_Func(
                                filteredData
                            )}`
                        )
                    );
                }}
            />

            <C_Report />
        </React.Fragment>
    );
};

export default RateListReport;
